import { init as pick } from './pick';
import { init as week } from './week';
import { init as standings } from './standings';
import { init as entrance } from './entrance';
import { init as sheet } from './sheet';
import { init as states } from './states';

/** Called once from main.ts after the shell exists. Each slice owns one file pair. */
export function initMotion(root: HTMLElement): void {
  for (const init of [pick, week, standings, entrance, sheet, states]) init(root);
}
